import React from "react";
import Base64Downloader from "common-base64-downloader-react";
import { IoMdDocument } from "react-icons/io";
import { FaDownload } from "react-icons/fa";

type props = {
  documentContent: any;
  documentName: string;
  documentType?: string;
};

const getMimeType = (documentType?: string) => {
  if (!documentType) return "application/pdf";
  const type = documentType.toLowerCase();
  if (type.includes("pdf")) return "application/pdf";
  if (type.includes("png")) return "image/png";
  if (type.includes("jpg") || type.includes("jpeg")) return "image/jpeg";
  if (type.includes("doc")) return "application/msword";
  if (type.includes("application")) return type;
  return "application/pdf";
};

const SingleDocument = (props: props) => {
  const { documentContent, documentName, documentType } = props;

  return (
    <li>
      <Base64Downloader
        base64={`data:${getMimeType(documentType)};base64,${documentContent}`}
        downloadName={documentName}
        className="fileDownloader"
      >
        <FaDownload /> {documentName}
      </Base64Downloader>
    </li>
  );
};

export default SingleDocument;
